/** Contentful center metadata tag for Trimble Developer news content. */
export const TRIMBLE_DEVELOPER_NEWS_CENTER_TAG = "centerTdNews"

/** Internal blog slug encoded in `_bp-{slug}` rewrite targets. */
export const TRIMBLE_DEVELOPER_NEWS_BLOG_SLUG = "tdnews"

/** Contentful `pageHome` slug for the TD news landing page. */
export const TRIMBLE_DEVELOPER_NEWS_LANDING_SLUG = "tdnews-landing"

/** User-facing URL prefix on trimble-developer builds only. */
export const TRIMBLE_DEVELOPER_NEWS_URL_PREFIX = "news"

export const TRIMBLE_DEVELOPER_MACHINE_NAME = "trimble-developer"
